import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={20.828}
    height="6.9mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 40841 51136"
    {...props}
  >
    <defs>
      <style>
        {/* {".str1{stroke:#1c1b17;stroke-width:564.718}.fil1{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M40470 14045v35432c0 708-580 1288-1290 1288H1659c-708 0-1288-580-1288-1288V14045h40099zM7711 6282c1027 0 1859 832 1859 1859 0 1026-832 1859-1859 1859s-1860-832-1860-1859 833-1859 1860-1859zm25418 0c1028 0 1861 832 1861 1859 0 1026-833 1859-1861 1859-1026 0-1858-832-1858-1859s832-1859 1858-1859zm-8472 0c1027 0 1860 832 1860 1859 0 1026-833 1859-1860 1859s-1860-832-1860-1859 833-1859 1860-1859zm-8473 0c1027 0 1860 832 1860 1859 0 1026-833 1859-1860 1859s-1860-832-1860-1859 833-1859 1860-1859zM4890 16624h32034v25622H3917V16624h973zM1659 2418h4371V371h11069v2047h6642V371h11071v2047h4368c710-1 1290 580 1290 1289v8392H371V3707c0-709 580-1289 1288-1289z"
        style={{
          fill: "none",
          // stroke: "#1c1b17",
          strokeWidth: 741.099,
        }}
        className="fill-none stroke1"
      />
      <path
        d="M8459 22580h23922v3138H8459z"
        className="fill stroke1"
        style={{
          strokeWidth: 564.718,
        }}
      />
      <circle
        cx={7710}
        cy={8141}
        r={1315}
        className="fill stroke1"
        style={{
          strokeWidth: 564.718,
        }}
      />
      <circle
        cx={16132}
        cy={8092}
        r={1315}
        className="fill stroke1"
        style={{
          strokeWidth: 564.718,
        }}
      />
      <circle
        cx={24567}
        cy={8118}
        r={1315}
        className="fill stroke1"
        style={{
          strokeWidth: 564.718,
        }}
      />
      <circle
        cx={33178}
        cy={8066}
        r={1315}
        className="fill stroke1"
        style={{
          strokeWidth: 564.718,
        }}
      />
    </g>
  </svg>
);
export default SvgComponent;
